import { Flex } from '@chakra-ui/react';
import BerryLoadGif from '@public/gif/berry-load.gif';
import Image from 'next/image';

export const BerryLoader = ({
  text,
  height,
}: {
  height?: string;
  text?: React.ReactNode;
}) => {
  return (
    <Flex
      width="100%"
      height={height ?? '100vh'}
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
    >
      <Image width={160} height={160} src={BerryLoadGif} alt="Loading" />
      {text ?? null}
    </Flex>
  );
};
